
import Logo from '@components/common/Logo';

const LoginHeader = () => {
    return (
        <div className="mb-8 text-center flex flex-col items-center">
            <Logo
                textSize="text-4xl"
                imageSize="w-16 h-16"
                showSubheading={true}
                subheadingSize="text-[11px]"
                className="mb-6"
            />
            <div className="flex flex-col items-center gap-2">
                <div className="h-[1px] w-12 bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />
                <h1 className="text-primary-200/70 font-sans text-xs tracking-[0.3em] font-semibold uppercase">
                    Sign in to your cosmic journey
                </h1>
                <div className="h-[1px] w-12 bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />
            </div>
        </div>
    );
};

export default LoginHeader;
